import PT from 'prop-types';
import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Popover } from '~/eds/src/components/Popover/Popover';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import Text from '~/ui/components/Text/Text';

export default function AddParticipantToTicketPopover({
  isVisible,
  participant,
  onClose,
  onSubmit,
}) {
  const intl = useIntl();
  const onAddParticipantClick = async () => {
    await onSubmit(participant);
  };

  return (
    <Popover trigger="" isVisible={isVisible}>
      <Layout
        w={250}
        p={2}
        data-testid="addParticipantPopover"
        direction="column"
        spacing={4}
      >
        {participant && (
          <Box>
            <FormattedMessage
              id="AddParticipantToTicketPopover.notAParticipant"
              defaultMessage="{participant} is not currently a participant in this ticket."
              description="Text indicating a user is not a participant in the ticket. The user's name precedes this text."
              values={{ participant: <Text isBold>{participant.name}</Text> }}
            />
          </Box>
        )}
        <Button
          isFullWidth
          text={intl.formatMessage({
            id: 'AddParticipantToTicketPopover.addAsParticipant',
            defaultMessage: 'Add as participant',
            description: 'Button text to add a user as a participant.',
          })}
          onClick={onAddParticipantClick}
          variant="primary"
          label={intl.formatMessage({
            id: 'AddParticipantToTicketPopover.addAsParticipantLabel',
            defaultMessage: 'Add as participant',
            description: 'Label for the add participant button.',
          })}
        />
        <Button
          data-testid="addParticipantPopover_cancel"
          isFullWidth
          text={intl.formatMessage({
            id: 'AddParticipantToTicketPopover.cancel',
            defaultMessage: 'Cancel',
            description: 'Cancel button text.',
          })}
          label={intl.formatMessage({
            id: 'AddParticipantToTicketPopover.cancelLabel',
            defaultMessage: 'Cancel',
            description: 'Label for the cancel button.',
          })}
          variant="ghost"
          onClick={onClose}
        />
      </Layout>
    </Popover>
  );
}

AddParticipantToTicketPopover.propTypes = {
  isVisible: PT.bool,
  participant: PT.shape({
    id: PT.number,
    name: PT.string,
  }),
  onClose: PT.func,
  onSubmit: PT.func,
  reference: PT.object,
  referenceOffset: PT.arrayOf(PT.number),
};
